import { Vector2, Mesh, Vector3 } from '@babylonjs/core';
import IShape from './IShape';

export enum ElementType {
    BODY,
    FRONT,
    INSIDE,
    HANDLE,
    LEGS,
    WALL,
}

export default class Element implements IShape {
    private static selectableTypes = [
        ElementType.FRONT, ElementType.INSIDE,
    ];

    public isSelected: boolean = false;

    private _width: number = 0;
    private _height: number = 0;
    private _depth: number = 0;

    public get width(): number { return this._width; }
    public get height(): number { return this._height; }
    public get depth(): number { return this._depth; }

    public get center(): Vector3 {
        return this.meshes.find((x) => x.position.isNonUniform)!.position;
    }

    public set center(position: Vector3) {
        this.moveMeshes(position);
    }

    public get isVisible(): boolean {
        return this.meshes.some((x) => x.visibility === 1);
    }

    public set isVisible(visibility: boolean) {
        this.meshes.forEach((x) => x.visibility = visibility ? 1 : 0);
    }

    public get isSelectable(): boolean {
        return Element.selectableTypes.includes(this.type);
    }

    public constructor(
        public position: Vector2,
        public shape: Vector2,
        public type: ElementType,
        public meshes: Mesh[],
    ) {
        this.setBoundingInfo();
    }

    public remove() {
        this.meshes.forEach((x) => x.dispose());
    }

    public toggleVisibility() {
        this.meshes.forEach((x) => x.visibility = 1 - x.visibility);
    }

    private moveMeshes(position: Vector3) {
        const meshes = this.meshes.filter((x) => x.position.isNonUniform);
        meshes.forEach((x) => x.position = position.clone());
    }

    private setBoundingInfo() {
        const mesh = this.meshes
            .find((x) => x.getBoundingInfo().boundingBox.centerWorld.isNonUniform)!;
        const boundingBox = mesh.getBoundingInfo().boundingBox;
        if (boundingBox === undefined) { return; }
        const min = boundingBox.minimumWorld;
        const max = boundingBox.maximumWorld;
        this._width = max.x - min.x;
        this._height = max.y - min.y;
        this._depth = max.z - min.z;
    }
}
